
import { CreateUpdateProductsComponent } from '../../../products/create-update-products/create-update-products.component';
import { Component, EventEmitter, OnDestroy } from '@angular/core';
import {
	ModalButtonModel,
	ModalButtonType
} from '@cv-invision/core';
import { GenericFormService } from "@cv-invision/cv.invision-views.ux";

@Component({
	templateUrl: '../../../products/create-update-products/create-update-products.component.html',
	styleUrls: ['../../../products/create-update-products/create-update-products.component.scss'],
	providers: [GenericFormService],
})
export class ShowProductModalComponent extends CreateUpdateProductsComponent implements OnDestroy {
	successEvent = new EventEmitter<any>();
	buttons: Array<any> = new Array<any>();
	viewMode: boolean = true;
	data: any;

	async ngOnInit(): Promise<void> {

		this.productId = this.data.productId;

		const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onCancel.bind(this)
		};

		this.buttons.push(cancelButton);

		super.ngOnInit();
	}

	/**
	 * Dismiss the Dialog
	 */
	public onCancelClose(result: any = {}): void {
		result.status = 'close';
		this.successEvent.emit(result);
	}

	/**
	 * Close the Dialog by Cancel/Close/Dismiss
	 * @param result
	 */
	onCancel(): void {
		const data = { cancel: true };
		this.onCancelClose(data);
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}
}
